module.exports = __webpack_public_path__ + "img/smart-plug-lg.8ff21c50.svg";